module.exports = __webpack_public_path__ + "img/20170704_135648_096.5f5ff2b2.jpg";